import { useStore } from 'react-redux'
import { SearchProviderActions } from 'actions/searchProvider'
import { SearchProviderRedux } from 'types/SearchProvider'

const useUpdatedSearchProviderRedux = () => {
  const store = useStore()

  const updateSearchProviderStore = (searchProvider: Partial<SearchProviderRedux>) => {
    store.dispatch(SearchProviderActions.UPDATE_SEARCH_PROVIDER(searchProvider))
  }

  return { updateSearchProviderStore }
}

export default useUpdatedSearchProviderRedux
